import { render, staticRenderFns } from "./NewsPostFiles.vue?vue&type=template&id=6e2ef83e&scoped=true"
import script from "./NewsPostFiles.vue?vue&type=script&lang=js"
export * from "./NewsPostFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ef83e",
  null
  
)

export default component.exports